import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment-timezone';
import Loading from '../../common/components/Loading';
import Icon from '../../common/icons/Icon';

class NewSessionModal extends Component {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
    onAccept: PropTypes.func.isRequired,
    onReject: PropTypes.func.isRequired,
    session: PropTypes.object.isRequired,
    toggleModal: PropTypes.func.isRequired,
  };

  state = {
    rejecting: false,
    responseNote: '',
    acceptedSessionDate: null,
  };

  onSelectDate = date => {
    this.setState({
      acceptedSessionDate: date,
    });
  };

  onUpdateNote = event => {
    this.setState({
      responseNote: event.currentTarget.value,
    });
  };

  acceptSession = () => {
    this.props.onAccept(this.state);
  };

  rejectSession = () => {
    this.props.onReject(this.state);
  };

  toggleRejecting = () => {
    this.setState(state => ({ rejecting: !state.rejecting }));
  };

  render() {
    const { loading, session, toggleModal } = this.props;
    const { acceptedSessionDate, rejecting, responseNote } = this.state;

    if (loading) {
      return <Loading />;
    }

    if (rejecting) {
      return (
        <div>
          <div className="booking-modal reject">
            <h3>Reject Session</h3>
            <div className="booking-textarea">
              <label>Please let the requester know why you're rejecting this session</label>
              <textarea value={responseNote} onChange={this.onUpdateNote} />
            </div>
          </div>
          <div className="modal__actions">
            <button
              className="button button--theme--plain"
              style={{ marginRight: '20px' }}
              type="button"
              onClick={this.toggleRejecting}
            >
              Cancel
            </button>
            <button className="button" type="button" onClick={this.rejectSession}>
              Submit
            </button>
          </div>
        </div>
      );
    }

    return (
      <div>
        <div className="booking-modal">
          <button className="close-button" onClick={toggleModal}>
            <Icon icon="Close" />
          </button>
          <div className="booking-modal--header">
            <Icon icon="Person" />
            <h3>{session.type === 'online' ? 'Online' : 'In-Person'} Follow-Up with Tathata</h3>
          </div>
          <div className="user-info">
            <div className="admin-paper__edit-content__row">
              <p>User Name</p>
              <span className="title">{session.user.name}</span>
            </div>
            <div className="admin-paper__edit-content__row">
              <p>User Email Address</p>
              <span className="title">{session.user.email}</span>
            </div>
            <div className="admin-paper__edit-content__row">
              <p>Hours</p>
              <span className="title">{session.hours}</span>
            </div>
          </div>
          {session.note && (
            <div className="booking-note">
              <i>"{session.note}"</i>
            </div>
          )}
          <div className="booking-times__wrapper">
            <p>Select a Time</p>
            <div className="booking-times">
              {session.requested_dates.map((date, index) => (
                <span
                  className={classnames('booking-time', {'accepted-time': acceptedSessionDate === date})}
                  key={index}
                  onClick={() => this.onSelectDate(date)}
                >
                  {moment(date)
                    .tz('America/Phoenix')
                    .format('MMM D, YYYY h:mmA z')}
                </span>
              ))}
            </div>
          </div>
          <div className="booking-textarea">
            <label>Leave a note for the requester:</label>
            <textarea value={responseNote} onChange={this.onUpdateNote} />
          </div>
        </div>
        <div className="modal__actions">
          <button
            className="button button--theme--secondary"
            style={{ marginRight: '20px' }}
            type="button"
            onClick={this.toggleRejecting}
          >
            Reject Session
          </button>
          <button className="button" type="button" onClick={this.acceptSession} disabled={!acceptedSessionDate}>
            Confirm Session
          </button>
        </div>
      </div>
    );
  }
}

export default NewSessionModal;



// WEBPACK FOOTER //
// ./src/follow-ups/home/NewSessionModal.js